import clsx from 'clsx';
import React, { useCallback } from 'react'
import { Offcanvas } from 'react-bootstrap'
import { useForm } from 'react-hook-form';
import { CreateCategoryFormData, CreateCategorySchema } from '../schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';

interface CreateCategoryDialogProps {
    show: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}

const CreateCategoryDialog: React.FC<CreateCategoryDialogProps> = ({ show, onClose, onSuccess }) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<CreateCategoryFormData>({
        resolver: zodResolver(CreateCategorySchema),
    });

    const handleClose = () => {
        reset();
        onClose();
    }

    const onSubmit = useCallback((data: CreateCategoryFormData) => {
        toast.loading('Creating category...', { id: 'create-category' });

        // TODO: Implement API call
        console.log('Creating category:', data);

        // Simulate API call
        setTimeout(() => {
            handleClose();
            toast.success('Category created successfully', { id: 'create-category' });
            onSuccess?.();
        }, 1000);
    }, [onSuccess]);

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" className="offcanvas-responsive">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Create Category</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column" style={{ height: '100%' }}>
                    <div className="action-sheet-content flex-grow-1">
                        {/* Name */}
                        <div className="row mb-3 align-items-center">
                            <label htmlFor="name" className="col-sm-4 col-form-label d-flex justify-content-md-end" style={{ fontSize: '14px' }}>Name: </label>
                            <div className="col-sm-8">
                                <input
                                    type="text"
                                    className={clsx("form-control app-form-control rounded-1", errors?.name && 'is-invalid')}
                                    id="name"
                                    placeholder="Category name"
                                    {...register('name')}
                                    style={{ fontSize: '14px', height: '35px' }}
                                />
                                {errors?.name && <div className="invalid-feedback">{errors.name.message}</div>}
                            </div>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="form-group mt-auto d-grid">
                        <button type="submit" className="btn btn-primary btn-block">
                            Create Category
                        </button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default CreateCategoryDialog